import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function NoExperienceResume() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="How to Write a Resume With No Experience (2026 Guide)"
        description="Learn how to write a resume with no experience. Proven tips, examples, and strategies to land your first job using AI tools from EmployPilot."
        canonical="https://employpilot.com/no-experience-resume"
      />

      <h1>How to Write a Resume With No Experience</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Don’t have work experience? You’re not alone — and it’s NOT a deal breaker.
        With the right strategy, you can still create a strong resume that gets interviews.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Build Your Resume Now
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What Employers Actually Look For</h2>

      <p>
        Employers don’t just look for job history — they look for:
      </p>

      <ul>
        <li>✔ Skills and potential</li>
        <li>✔ Work ethic and reliability</li>
        <li>✔ Communication ability</li>
        <li>✔ Willingness to learn</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What to Put on a Resume With No Experience</h2>

      <ul>
        <li>✔ Education</li>
        <li>✔ Relevant skills</li>
        <li>✔ Projects or school work</li>
        <li>✔ Volunteer experience</li>
        <li>✔ Certifications (if any)</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Best Resume Format for Beginners</h2>

      <p>
        Use a <strong>skills-based (functional)</strong> resume instead of a traditional one.
      </p>

      <p>
        👉 Focus on what you CAN do — not what you haven’t done yet.
      </p>

      <p>
        Need help choosing a format?{" "}
        <Link to="/best-resume-format">See best resume formats</Link>
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Example Resume (No Experience)</h2>

      <div style={{ background: "#f9f9f9", padding: "20px", borderRadius: "8px" }}>
        <p><strong>John Doe</strong></p>
        <p>Motivated and detail-oriented individual seeking entry-level opportunities.</p>

        <p><strong>Skills:</strong></p>
        <ul>
          <li>Communication</li>
          <li>Teamwork</li>
          <li>Problem-solving</li>
        </ul>

        <p><strong>Education:</strong></p>
        <p>High School Diploma / College Student</p>
      </div>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Pro Tips to Stand Out</h2>

      <ul>
        <li>✔ Tailor your resume for each job</li>
        <li>✔ Use strong action words</li>
        <li>✔ Keep it clean and simple</li>
        <li>✔ Add measurable achievements (even small ones)</li>
      </ul>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Want better summaries?{" "}
        <Link to="/resume-summary-examples">
          See resume summary examples
        </Link>
      </p>

      <p>
        Preparing for interviews?{" "}
        <Link to="/tell-me-about-yourself">
          Master your interview answers
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Building Your Resume Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Create Resume Free
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>Frequently Asked Questions</h2>

      <h3>Can I get a job with no experience?</h3>
      <p>Yes. Many entry-level jobs are designed for people without experience.</p>

      <h3>What if I have no skills?</h3>
      <p>You DO have skills — think school, teamwork, communication, or personal projects.</p>

      <h3>How long should my resume be?</h3>
      <p>Keep it to one page, especially as a beginner.</p>

      <h3>Should I include hobbies?</h3>
      <p>Only if they demonstrate relevant skills or discipline.</p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default NoExperienceResume;